"use client";
import { Video } from "@/type/video";
import { createContext, useContext, useState } from "react";

const SearchExtractContext = createContext<any>(null);

export function SearchExtractProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [info, setInfo] = useState<Video[]>();
  return (
    <SearchExtractContext.Provider value={{ info, setInfo }}>
      {children}
    </SearchExtractContext.Provider>
  );
}

export function useSearchExtract() {
  return useContext(SearchExtractContext);
}
